export const theme = {
  blue: '#4899C7',
  pink: '#CE7CA7',
  green: '#47AE4B',
  orange: '#E5908A',
  grey: '#7D7D7D',
};
